import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

import { VariantClass, Variants } from './skeleton.constant';

@Component({
    selector: 'ms-skeleton',
    template: '',
    styleUrl: './skeleton.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[style.--skeleton-width]': 'width()',
        '[style.--skeleton-height]': 'height()',
    },
})
export class SkeletonComponent {
    width = input<string>();
    height = input<string>();
    variant = input<Variants>('text');

    @HostBinding('class') get cssClass(): string {
        return VariantClass[this.variant()];
    }
}
